import { Component, type ErrorInfo, type ReactNode } from "react";
import { trackError } from "../lib/analytics";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    trackError(error);
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: "24px", textAlign: "center", color: "#6b7280" }}>
          <p><strong>Something went wrong</strong></p>
          <p style={{ fontSize: "14px" }}>Please refresh the page to try again.</p>
        </div>
      );
    }
    return this.props.children;
  }
}
